import { excludeNull } from "@/shared/lib/collection";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { DeliveryRoute } from "@/widgets/delivery-route/ui";
import { Box, Stack } from "@mui/material";
import type { DraftOfferCargo } from "../../model";

export const DestinationsInfo = (props: {
  draftOfferCargo: DraftOfferCargo;
}) => {
  return (
    <BaseHeaderWrapper title="配送ルート">
      <Stack spacing={5} maxWidth="628px">
        <Box
          position="relative"
          padding="24px 16px"
          border="1px solid"
          borderColor="grey.200"
          borderRadius="16px"
        >
          <DeliveryRoute
            baseOfferCargo={{
              ...props.draftOfferCargo,
              destinations: props.draftOfferCargo.destinations.map(
                (destination) => {
                  const address = excludeNull([
                    destination.city,
                    destination.addressLine,
                  ]).join(" ");
                  return { ...destination, address };
                },
              ),
            }}
          />
        </Box>
        {props.draftOfferCargo.destinationFiles && (
          <BaseKeyValue keyLabel="添付ファイル">
            {props.draftOfferCargo.destinationFiles.map((file) => (
              <Box key={file.name}>{file.name}</Box>
            ))}
          </BaseKeyValue>
        )}
      </Stack>
    </BaseHeaderWrapper>
  );
};
